import { render, staticRenderFns } from "./DefaultViews.vue?vue&type=template&id=206d2e7e&scoped=true"
import script from "./DefaultViews.vue?vue&type=script&lang=js"
export * from "./DefaultViews.vue?vue&type=script&lang=js"
import style0 from "./DefaultViews.vue?vue&type=style&index=0&id=206d2e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d2e7e",
  null
  
)

export default component.exports